/**
 * Job status constants
 */
export const JOB_STATUS = {
  QUEUED: 'queued',
  RUNNING: 'running',
  WAITING: 'waiting',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  TIMEOUT: 'timeout',
  CANCELED: 'canceled',
};

/**
 * Check if job status is terminal (won't change anymore)
 */
export function isTerminalStatus(status) {
  return [
    JOB_STATUS.SUCCEEDED,
    JOB_STATUS.FAILED,
    JOB_STATUS.TIMEOUT,
    JOB_STATUS.CANCELED,
  ].includes(status);
}

/**
 * Check if job needs user attention
 */
export function needsReview(job) {
  return job.status === JOB_STATUS.WAITING && job.stage === 'REVIEWING';
}

